'use client'

import { Box, Button } from '@mantine/core'
import Link from 'next/link'
import { useBreakpoint } from '@/hooks/useBreakpoints'
import classes from './InsurancePill.module.css'

export default function InsurancePill() {
    const { isSm } = useBreakpoint()

    // Removed animation for faster LCP - text renders immediately
    return (
        <Box className={`${classes.container} ${isSm ? classes.mobileContainer : ''}`}>
            <Box className={`${classes.pill} ${isSm ? classes.mobilePill : ''}`}>
                <Box component="p" className={classes.text}>
                    {isSm ? 'We accept most insurance.' : 'Insurance accepted, up-front pricing, no hidden fees.'}
                </Box>
                <Button
                    component={Link}
                    href="/insurance"
                    prefetch={false}
                    className={`${classes.button} ${isSm ? classes.mobileButton : ''}`}
                >
                    See my copays
                </Button>
            </Box>
        </Box>
    )
}
